import Layout from '@/layout/layout'

const oldPhoneTrace = {
  path: '/oldPhoneTrace',
  component: Layout,
  redirect: 'noRedirect',
  name: '旧机跟踪',
  children: [
    {
      path: 'abnormalArrival',
      component: () => import('@/views/oldPhoneTrace/abnormalArrival/index'),
      name: '异常到货跟踪',
      meta: { title: '异常到货跟踪', noCache: true }
    },
    {
      path: 'oldPhoneDeliver',
      component: () => import('@/views/oldPhoneTrace/oldPhoneDeliver/index'),
      name: '旧机发货跟踪',
      meta: { title: '旧机发货跟踪', noCache: true }
  }
  ]
}

export default oldPhoneTrace